import React from "react";
import Carousel from "react-elastic-carousel";
import Styled from "../components/Styled";
import { state } from "../rawData/kidsAPI";
import {  IoIosArrowBack , IoIosArrowForward} from 'react-icons/io';
import "../css/circle.css";


const breakPoint = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 4 },
  { width: 768, itemsToShow: 6 },
  { width: 1024, itemsToShow: 6 },
];

const CircleCarousel = () => {
  return (
    <>
      <div className=" cards-container2">
        <div className="mt-4 mb-4">
          <h4 className="text-center">Browse by category</h4>
          <Carousel
            itemPadding={[3]}
            breakPoints={breakPoint}
            renderArrow={({ type, onClick }) => {
              
              return (
                <div onClick={onClick}>
                  {type === "NEXT" ? (
                    <button className="btnn">
                      <IoIosArrowForward />
                    </button>
                  ) : (
                    <button className="btnn">
                      <IoIosArrowBack />
                    </button>
                  )}
                </div>
              );
            }}
          >
            {state.map((items) => (
              <Styled src={items.image} alt={items.alt} />
            ))}
          </Carousel>
        </div>
      
      </div>
    </>
  );
};

export default CircleCarousel;
